import { render, staticRenderFns } from "./ModalLuxRuleEdit.vue?vue&type=template&id=4661ab18&scoped=true"
import script from "./ModalLuxRuleEdit.vue?vue&type=script&lang=js"
export * from "./ModalLuxRuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxRuleEdit.vue?vue&type=style&index=0&id=4661ab18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661ab18",
  null
  
)

export default component.exports